import CardSystem, { getCardHandler } from '../CardSystem';
import Renderable from '../../../Component/Renderable';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import GameObject from '../../../GameObject/GameObject';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import Animator from '../../../Prototype/Animator';
import { UIEvent } from '../../UI/BaseUISystem';
import { ICardStateTaskData } from '../../../State/Card/ICardState';

export default function TntCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    system.scene.emit(UIEvent.DISABLE_INTERACTIVITY, false);
    const targets: {
        card: BaseCard;
        score: number;
    }[] = taskData.targets.map((target: any) => {
        return {
            card: system.getCardByID(target.cardID),
            score: target.score,
        };
    });

    const tntAnimator = GameObject.Instantiate(Animator);
    system.animator.addChild(tntAnimator);

    for (let target of targets) {
        tntAnimator.addChild(target.card);
        target.card.getComponent(Renderable).visible = true;

        // update cards modifiers since they are still on board (in play), but discarded
        const handler = getCardHandler(target.card);
        handler.handleCardInPlay(system.store.getState().levelState.cardsState, system);
    }

    system.taskQueue.queueNext(
        new CardAnimationTask(taskData, system, 'BoosterTNT', tntAnimator, {
            targets: targets,
            flipCard: taskData.flipCard
        })
    );
}
